import { render } from "./DashboardEvents.vue?vue&type=template&id=2cc1bb06&scoped=true&ts=true"
import script from "./DashboardEvents.vue?vue&type=script&lang=ts"
export * from "./DashboardEvents.vue?vue&type=script&lang=ts"

import "./DashboardEvents.vue?vue&type=style&index=0&id=2cc1bb06&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc1bb06"]])

export default __exports__